import React, { Component } from "react";
import "./App.css";
import MainPage from "./components/MainPage";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { ConfigureStore } from "./redux/configureStore";
import ScrollToTop from "./components/partials/ScrollToTop";

// Updated imports
import { connect } from "react-redux";
import * as actions from "./Pages/ReduxStore/slices/cartSlice";
import { autoLogin } from "./Pages/ReduxStore/slices/authSlice";
import MerchandiseStore from "./Pages/MerchandiseStore/MerchandiseStore";
import Checkout from "./Pages/Checkout/Checkout";
import { createContext } from "react";
import Transaction from "./Pages/Transaction/Transaction";
import { Switch, Route } from "react-router-dom";
import ProblemList from "./Pages/ProblemList/ProblemList";
import Profile from "./Pages/Profile/Profile";
import GlobalLeaderboard from "./Pages/GloabalLeaderboard/GlobalLeaderboard";
import Leaderboard from "./Pages/Leaderboard/Leaderboard";
import Submissions from "./Pages/Submissions/Submissions";
import ForgetPassword from "./Pages/ForgetPassword/ForgetPassword";
import ResetPassword from "./Pages/ResetPassword/ResetPassword";
import ProtectedRoute from "./components/partials/ProtectedRoute";
import ShippingPolicy from "./Pages/FooterLinks/ShippingPolicy";
import RefundPolicy from "./Pages/FooterLinks/RefundPolicy";
import TermsNCondition from "./Pages/FooterLinks/TermsNConditions";
import { customerly } from "react-customerly";

// const store = ConfigureStore();
class App extends Component {
  componentDidMount() {
    this.props.loadCart();
    this.props.autoLogin();
    customerly.initialize("12d97169", { direction: "right" });
  }

  render() {
    return (
      // <Provider store={store}>
      <BrowserRouter>
        <Switch>
          <Route path="/store" component={MerchandiseStore} />
          {/* <ProtectedRoute exact path="/checkout" component={Checkout} /> */}
          <Route path="/checkout/shipping-policy" component={ShippingPolicy} />
          <Route path="/checkout/refund-policy" component={RefundPolicy} />
          <Route
            path="/checkout/terms-and-conditions"
            component={TermsNCondition}
          />
          <Route path="/transaction" component={Transaction} />
          <Route path="/leaderboard" component={GlobalLeaderboard} />
          <ProtectedRoute path="/users/:username" component={Profile} />
          <Route path="/password/forgot" component={ForgetPassword} />
          <Route path="/password/reset" component={ResetPassword} />
          {/* <ProtectedRoute exact path="/contests/:contestId/problem" component={ProblemList} /> */}
          <ProtectedRoute
            exact
            path="/contests/:contestId/problems/leaderboard"
            component={Leaderboard}
          />
          <ProtectedRoute
            exact
            path="/contests/:contestId/problems/submissions"
            component={Submissions}
          />
          <Route
            path="/"
            render={() => (
              <ScrollToTop>
                <MainPage />
              </ScrollToTop>
            )}
          />
        </Switch>
      </BrowserRouter>
      // </Provider>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    username: state.auth.username,
    isAuthenticated: state.auth.isAuthenticated,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadCart: () => dispatch(actions.loadCart()),
    autoLogin: () => dispatch(autoLogin()),
  };
};

export default connect(null, mapDispatchToProps)(App);
